<template>
  <div v-if="showBasketListFooter() && !isBasketEmpty()" class="basket-list-footer">
    <div>
      <div class="button-enter-coupon" @click="openCertificateModal()" v-if="isDevMode">
        {{ phrases.ENTER_PROMOCODE }}
      </div>
      <ModalTemplate v-if="showModalCertificate" box-class="notification-box-default enter-certificate-modal"
                     on-close="basket/setIsOpenCertificateModal">
        <template slot="body">
          <Promocode/>
        </template>
      </ModalTemplate>
      <div v-if="items.length" class="basket-button-checkout goal-checkout"
           @click="setCheckout()">{{phrases.BASKET_PLACE_AN_ORDER}}</div>
    </div>
  </div>
</template>

<script>
import Promocode from "./Promocode";
import ModalTemplate from "../partial/modal-template";
import Utils from "../Utils";
import BasketUtils from "./BasketUtils";
import {mapGetters} from "vuex";

export default {
  name: "BasketListFooter",
  computed: {
    ...mapGetters('order', {
      items: 'basketItems'
    }),
    ...mapGetters('basket', {
      showModalCertificate: 'getIsOpenCertificateModal'
    }),
    ...mapGetters('app', {
      isDevMode: 'getIsDevMode'
    }),
  },
  components: {
    Promocode,
    ModalTemplate
  },
  mixins: [Utils, BasketUtils]
}
</script>

<style lang="scss">
  .button-enter-coupon{
    padding: 0.5rem;
    font-family: 'Panton Bold';
    text-align: center;
    cursor: pointer;
  }

  .notification-box-default{
    &.enter-certificate-modal{
      max-width: 400px;
    }
  }
</style>